<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter && show_laminated_option" class="designeroption">
            <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                <i class="fa fa-circle-question"></i>
                <span v-html="floating_sidebar_message"></span>
            </div>
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>
                    {{ title }}
                    <span v-if="show_help_text" data-designer-help-text="{{help_text}}"><i class="fa fa-question-circle help-text-icon"></i></span>
                </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
                <span v-if="fabricator == 20 && [136,137,138,150].includes(door_range)" style="width: 90px; min-width: 90px;">
                    <img :src="'/images/barbican/pas24_logo.png'">
                </span>
            </div>
            <div v-if="extra_html !== null" v-html="extra_html"></div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Laminated Glass:';
                }
            },
            component_id: {
                default(){
                    return 'laminated_glass';
                }
            },
            securedByDesign: {
                required: true,
            },
            slab: {
                required: true
            },
            frameStyle: {
                required: true
            },
            sidePanels: {
                required: true
            },
            help_text: {
                default(){
                    return 'Laminated glass is a type of safety glass that holds together when shattered';
                }
            },
            show_help_text: {
                default(){
                    return false;
                }
            },
            collection: {
                required: false,
                default(){
                    return '';
                }
            },
            door_range: {
              required: false,
              default(){
                return '';
              }
            },
            doorLocation: {
              required: false,
              default(){
                return '';
              }
            },
            floating_sidebar_message: {
                default(){
                    return '';
                }
            },
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            url(){
                return '/api/options/' + this.fabricator + '/laminated-glass?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&left=' + this.get_side('left') + '&right=' + this.get_side('right') + '&top=' + this.get_side('top') + '&comp_left=' + this.get_side('left_composite_id') + '&comp_right=' + this.get_side('right_composite_id') + '&collection=' + this.collection + '&door_range=' + this.door_range + '&door_location=' + this.doorLocation;
            },
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.slab, this.frameStyle, this.sidePanels, this.door_range);
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.slab + '_' + this.get_side('left') + '_' + this.get_side('right') + '_' + this.get_side('top') + '_' + this.get_side('left_composite_id') + '_' + this.get_side('right_composite_id') + '_' + this.collection + '_' + this.door_range + '_' + this.doorLocation;
            },
            show_laminated_option(){
                return this.filtered_option_list.length > 1 || (this.filtered_option_list.length > 1 && this.filtered_option_list[0].value === 2);
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'frameStyle': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
                deep: true
            },
            'sidePanels': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
                deep: true
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'collection': function (val, oldVal) {
                this.update_options();
            },
            'door_range': function (val, oldVal) {
              this.update_options();
            },
            'door_location': function (val, oldVal) {
              this.update_options();
            },
        },
        methods: {
            get_side(side) {
                if (side == 'top') {
                    if (this.frameStyle.checkedPanels.indexOf("top") !== -1) {
                        return 1;
                    }
                    return 0;
                }
                if (!this.isFiredoor && this.sidePanels[side]) {
                    if (side == 'left' || side == 'right') {
                        if (this.frameStyle.checkedPanels.indexOf(side) !== -1) {
                            return this.sidePanels[side];
                        }
                        return 0;
                    }
                    return this.sidePanels[side];
                }
                return 0;
            }
        }
    }
</script>
